import { axiosApi } from "services/api";

// API call for sending a contact request
export const sendContactUsRequest = async (token, data) => {
    try {
        const response = await axiosApi.post("/contact", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        throw error; // Throw the error to be handled in the action/reducer
    }
};